import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { createStore } from '../../../../../../shared/state-store/core/createStore.ts';
import { CreatorProduct } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/types.ts';
import { createLogger } from '../../../../../../shared/state-store/core/middlewares/createLogger.ts';
import {
  CreatorProductActionsDef,
  CreatorProductState,
  NewModeComputedDef,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/store/types.ts';
import {
  setError,
  setField_higherOrder,
  validateForm,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/store/actions.ts';
import { getStoresProductSchema } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/store_product.ts';
import { createInitialEmptyValuesFromSchema } from '../../../../../../shared/zod-helper/createInitialEmptyValuesFromSchema.ts';

const createInitialState = <T extends MODE>(mode: T): CreatorProductState<T> => {
  return {
    mode,
    formData: createInitialEmptyValuesFromSchema(getStoresProductSchema(mode)),
    errors: {},
  };
};

export const createCreatorProductStore = <T extends MODE>(
  mode: T,
  initialFormData?: Partial<CreatorProduct<T>>,
) => {
  const defaultState = createInitialState(mode);

  return createStore<CreatorProductState<T>>()
    .initialState({
      ...defaultState,
      formData: initialFormData ? { ...defaultState.formData, ...initialFormData } : defaultState.formData,
    })
    .computed<NewModeComputedDef<T>>({
      isFormValid: (state) => {
        return !Object.values(state.errors).some((error) => error !== null);
      },
      toStoreProduct: (state) => {
        return state.formData;
      },
    })
    .actions<CreatorProductActionsDef<T>>({
      setField: setField_higherOrder,
      validateForm,
      setError,
    })
    .middleware([createLogger()])
    .devTool('createProduct')
    .build();
};
